import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    detection: {
      order: ['path', 'localStorage', 'htmlTag'],
      lookupFromPathIndex: 1,
      lookupLocalStorage: 'ly_language',
      caches: ['localStorage'],
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react!!
    },
    react: {
      useSuspense: false,
    },
    ns: ['common'],
    parseMissingKeyHandler: (key) => '',
  });

export default i18n;
